export default "__VITE_ASSET__DtjZl_JqXpOkzYScCvawLg__"